var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('listado',{ref:"listadoImg",attrs:{"tipo":2},on:{"agregar":_vm.anadirImagen}}),_c('modal-anadir-imagen',{ref:"modalAnadirImagen",on:{"update":_vm.updateView}}),_c('modal-duplicar-imagen',{ref:"modalDuplicarImagen"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }